export default __webpack_public_path__ + "static/media/Screenshot 2022-03-21 162917.d5de5729.png";